import type { II18nRepository, LocaleMessages } from '@/domain/repositories/i18n.repository'

/**
 * Базовый URL для загрузки файлов локализации из public/i18n.
 * В браузере — относительный путь от origin, на сервере — через runtimeConfig или пустая строка для относительного.
 */
function getI18nBaseUrl(): string {
  if (import.meta.client && typeof window !== 'undefined') {
    return window.location.origin
  }
  return ''
}

/**
 * Реализация репозитория локализации: загрузка сообщений из public/i18n/{locale}.json
 */
export class I18nRepository implements II18nRepository {
  private static instance: I18nRepository | null = null

  constructor(private readonly baseUrl: string = getI18nBaseUrl()) {}

  static getInstance(baseUrl?: string): I18nRepository {
    if (!I18nRepository.instance) {
      I18nRepository.instance = new I18nRepository(baseUrl ?? getI18nBaseUrl())
    }
    return I18nRepository.instance
  }

  static resetInstance(): void {
    I18nRepository.instance = null
  }

  async loadMessages(locale: string): Promise<LocaleMessages> {
    const base = this.baseUrl ? `${this.baseUrl}/i18n/${locale}.json` : `/i18n/${locale}.json`
    // Cache-bust: avoid stale JSON when translations are updated
    const url = `${base}?v=2`
    const data = await $fetch<LocaleMessages>(url)
    return data
  }
}
